import { render, staticRenderFns } from "./shop-compensate-component.vue?vue&type=template&id=0c04fa68&scoped=true&"
import script from "./shop-compensate-component.vue?vue&type=script&lang=js&"
export * from "./shop-compensate-component.vue?vue&type=script&lang=js&"
import style0 from "./shop-compensate-component.vue?vue&type=style&index=0&id=0c04fa68&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c04fa68",
  null
  
)

export default component.exports